"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SvgCurrencyRupeeCircle = function (props) { return ((0, jsx_runtime_1.jsx)("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 1C5.925 1 1 5.925 1 12s4.925 11 11 11 11-4.925 11-11S18.075 1 12 1ZM7.5 6.5a1 1 0 0 1 1-1h7a1 1 0 1 1 0 2h-1.84c.28.465.47.977.575 1.5H15.5a1 1 0 1 1 0 2h-1.265a4.552 4.552 0 0 1-.972 2.052 4.019 4.019 0 0 1-2.126 1.314l3.496 2.86a1 1 0 0 1-1.266 1.548l-5.494-4.495A.996.996 0 0 1 7.5 13.5v-.001a1.003 1.003 0 0 1 .547-.89.996.996 0 0 1 .453-.109H10c.822 0 1.375-.312 1.737-.74.183-.216.328-.475.429-.76H8.5a1 1 0 1 1 0-2h3.666a2.432 2.432 0 0 0-.43-.76c-.361-.428-.914-.74-1.736-.74H8.5a1 1 0 0 1-1-1Z", fill: "currentColor" }) }))); };
exports.default = SvgCurrencyRupeeCircle;
